// SmsPhraseInput.js
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/system';
import { TextField, Button } from '@mui/material';
import { useSnackbar } from 'notistack';
import { AppPalette } from '../../model/AppConst';

export default function SmsPhraseInput({
    open,
    isEdit,
    item,
    onClose,
    onClickMutate,
    responseSaving
}) {
    const [phrase, setPhrase] = useState(item ? item.phrase : '');
    const [changed, setChanged] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const {loading:loadingSave, error:errorSave, data:resultSave} = responseSaving;

    useEffect(() => {
        if(open) {
            if(isEdit && item) setPhrase(item.phrase || '');
            else setPhrase('');
            setChanged(false);
        }
    }, [open, isEdit, item]);

    const onClickSubmit = () => {
        if(!phrase) {
            enqueueSnackbar("문구를 입력하지 않았습니다.",
                { variant: AppPalette.WarnColor, autoHideDuration: 2500 });
            return;
        }
        const param = isEdit ? {
            phraseId: item.phraseId,
            phrase: phrase
        } : {
            phrase: phrase
        };
        onClickMutate(param);
    };

    return (
        <Box style={{display:'flex', alignItems:'center', flexGrow:1}}>
            <span>자주 쓰는 문구 {isEdit ? '수정' : '추가'}</span>
            <Box style={{flexGrow:1, marginLeft: 10}}>
                <TextField value={phrase} variant="outlined" size="small"
                    error={changed && !phrase}
                    fullWidth
                    onChange={(e)=>{setPhrase(e.target.value); setChanged(true);}} />
            </Box>
            <Button onClick={onClickSubmit}
                variant="contained" color="primary"
                style={{marginLeft: 10}}
                disabled={loadingSave || !phrase}
            >저장</Button>
            <Button onClick={()=>{onClose()}}
                variant="contained" color="inherit"
                style={{marginLeft: 10}}
            >취소</Button>
        </Box>
    )
}
